
/**
 * 
 * Description: Utility file for validation of user 
 * Author: Guryash Singh Dhall
 * From scratch
 */

// Email validation to check its syntax and whether it is empty.
export const validateEmail = (email) => {
  if (!email) {
    return "Email is required"
  }
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email)) {
    return "Email address is invalid";
  }
  else {
    return "";
  }
}


// Validation of name in registration form to ensure only alphabets are added.
export const validateName = (name) => {
  let msg = "";
  if (!name) {
    msg = "Name is required"
  }
  else if (!isAlphabet(name)) {
    msg = "Please enter alphabets only"
  }
  return msg;
}


// Main validate function for registration that will validate each field in the form.
export default function validate(data) {
  let errors = {}

  //Email Validation
  errors.email = validateEmail(data.get("email"));

  // Password Validation
  errors.password = validatePassword(data.get("password"));
  errors.name = validateName(data.get("name"));


  errors.confirmPassword = validateConfirmPassword(data.get("cnf_password"),data.get("password"));
  return errors;
}

// validation to check whether the input field is alphabets only.
export const isAlphabet = (value) => {
  let isValid = true;
  let pattern = new RegExp(/^[A-Za-z]+$/);
  if (!pattern.test(value)) {
    isValid = false;
  }
  return isValid;
};

// Password Validation
export const validatePassword = (value) => {
  let errorMsg = "";
  let pattern = new RegExp(/^[a-zA-Z0-9!@#$&()`%^*_=.+,/"'-]*$/);
  const password = value;
  if (!password) {
    errorMsg = "password is required";
  } else if (password.length < 8) {
    errorMsg = "Password needs to be 8 characters or more";
  } else if (!pattern.test(value)) {
    errorMsg = "Password should be alphanumeric";
  } else {
    errorMsg = "";
  }
  return errorMsg;
};

// Confirm password validation

export const validateConfirmPassword = (value, pwd) => {
  let isValid = true;
  let errorMsg = "";
  //matchPassword validation
  if (!value) {
    errorMsg = "confirm password is required";
  } 
  else if (value !== pwd) {
    errorMsg = "Password does not match confirmation password";
  } else {
    errorMsg = "";
  }
  return errorMsg;
};
